package one.healthium.profile.navigation.log_water

import androidx.compose.runtime.Composable
import one.healthium.log_water.ui.LogWaterScreen

@Composable
fun LogWaterContent(component: LogWaterComponent) {
    LogWaterScreen(component.taskId, component)
}